var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"JNPF-common-layout-footer"},[_c('p',[_vm._v("© 中科华予（北京）健康医学研究院 | 京ICP备17003064号")]),_c('p',[_vm._v("全国统一客服热线  :  "),_c('span',[_vm._v("400-8484-833  /  028-87775609")])]),_c('p',[_vm._v("地址：北京市海淀区苏州街20号院1号楼银丰大厦1406")])])
}]

export { render, staticRenderFns }